import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IonButton } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';

import { AuthService } from '@core/services/auth/auth';
import { NotificationService } from '@core/services/notification/notification';

@Component({
  selector: 'yt-web-push-banner',
  templateUrl: 'web-push-banner.html',
  styleUrls: ['web-push-banner.scss'],
  imports: [IonButton, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WebPushBanner {
  private readonly notificationService = inject(NotificationService);
  private readonly authService = inject(AuthService);

  protected readonly showBanner = this.notificationService.showWebPushBanner;
  protected readonly isAuthenticated = this.authService.isAuthenticated;

  protected async enable() {
    await this.notificationService.enableWebNotifications();
    await this.notificationService.dismissWebPushPrompt();
  }

  protected async dismiss() {
    await this.notificationService.dismissWebPushPrompt();
  }
}
